/**
 * Общий маркер блокировки прокрутки shell (мобильный drawer/оверлей).
 * Пока маркер установлен, менеджер переходов не сохраняет «сброшенный» scroll
 * (блокировка меняет scrollTop документа) и использует последнюю стабильную позицию.
 */
export const STAFF_SCROLL_LOCK_ATTR = 'data-staff-scroll-lock';

export function isStaffScrollLocked(): boolean {
  return (
    typeof document !== 'undefined' &&
    document.documentElement.hasAttribute(STAFF_SCROLL_LOCK_ATTR)
  );
}
